const isLocalhostHost = (hostname) => hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';

export function isPushSupported() {
    if (typeof window === 'undefined') {
        return false;
    }

    return (
        'serviceWorker' in navigator &&
        'PushManager' in window &&
        'Notification' in window
    );
}

export function hasPushSecureContext() {
    if (typeof window === 'undefined') {
        return false;
    }

    return window.isSecureContext || isLocalhostHost(window.location.hostname);
}

export async function registerPushServiceWorker() {
    if (!isPushSupported() || !hasPushSecureContext()) {
        return null;
    }

    return navigator.serviceWorker.register(`${process.env.PUBLIC_URL || ''}/push-sw.js`);
}

export function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const normalized = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(normalized);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; i += 1) {
        outputArray[i] = rawData.charCodeAt(i);
    }

    return outputArray;
}
